/* eslint-disable menti-react/filename-convention--jsx */
'use client';

import type * as React from 'react';
import { useHasMounted } from '@mentimeter/react-hooks';

interface RenderOnClientProps {
  children: React.ReactNode;
}

// This component forces the children to render only on the client side.
// To get HTML return from server-side this has to be removed, you should
// work on removing this wrapper from your page.
export function RenderOnClient({ children }: RenderOnClientProps) {
  const hasMounted = useHasMounted();

  if (!hasMounted) {
    return null;
  }

  return children;
}
